
import styles from './notFound.module.css';
import { MarkupLayout } from '../../components/ui/markupLayout/MarkupLayout';
import { Button } from '../../components/ui/button/Button';

export const NotFound = () => {
  return (

    <section >
      <MarkupLayout>
        <div className={styles.section}>
          <img className={styles.img} src="/images/404.png" alt="" />
          <div className={styles.container}>
            <div className={styles.content}>
              <h1 className={styles.title}>Уууппс...</h1>
              <p className={styles.subtitle}>
                К сожалению, запрашиваемая страница не найдена, кто-то испортил фильтр
              </p>
              <p className={styles.text}>
                Но вы всегда можете вернуться,<br />
                и начать сначала!
              </p>
            </div>

            <div className={styles.button_container}>
              <Button variant={"yellow"} link='/' behaviour='link' width='w-310' fontWeight='bold'>
                На главную
              </Button>
            </div>
            <div className={styles.copyright}>
              «SCT GERMANY» 2024 © Все права защищены!
            </div>
          </div>
        </div>
      </MarkupLayout>

    </section>

  );
};

